// Stripe product and price IDs for subscription tiers
export const SUBSCRIPTION_TIERS = {
  essential: {
    name: "Essential",
    product_id: "prod_UEtjNqp2QxEUAU",
    monthly: {
      price_id: "price_1TGPvm3ztn93p202zagUKMcx",
      price: 15,
      label: "$15/mo",
    },
    yearly: {
      price_id: "price_1TGPwA3ztn93p202VEyYDavg",
      price: 150,
      label: "$150/yr",
      savings: "Save $30",
    },
    features: [
      "All 3 visualization types",
      "AI-personalized scripts",
      "Premium voice selection",
      "Session library & favorites",
      "Mental performance tracking",
      "1 visualization per week",
    ],
  },
  elite: {
    name: "Elite",
    product_id: "prod_UEtljNjAZvOI8w",
    monthly: {
      price_id: "price_1TGPxX3ztn93p202Cmhpy7R0",
      price: 25,
      label: "$25/mo",
    },
    yearly: {
      price_id: "price_1TGPyV3ztn93p202LDNaxdgw",
      price: 250,
      label: "$250/yr",
      savings: "Save $50",
    },
    features: [
      "Everything in Essential",
      "3 visualizations per week",
      "Priority AI generation",
      "Advanced analytics",
      "Early access to new features",
      "Priority support",
    ],
  },
} as const;


// One-time credit purchase
export const CREDIT_PURCHASE = {
  product_id: "prod_UEvBBzFQ7Chlbq",
  price_id: "price_1TGRLZ3ztn93p202vYQBBlXv",
  price: 6,
  label: "$6 per credit",
} as const;

// Weekly limits by tier
export const WEEKLY_LIMITS: Record<string, number> = {
  essential: 1,
  elite: 3,
};

export type SubscriptionTier = "essential" | "elite";

export function getTierByProductId(
  productId: string | null
): SubscriptionTier | null {
  if (!productId) return null;
  if (
    productId === SUBSCRIPTION_TIERS.essential.product_id ||
    productId === "prod_UEtjCvGEr9bAFw"
  ) {
    return "essential";
  }
  if (
    productId === SUBSCRIPTION_TIERS.elite.product_id ||
    productId === "prod_UEtmKbUf5akL9u"
  ) {
    return "elite";
  }
  return null;
}

export function getWeeklyLimitForTier(tier: SubscriptionTier | null): number {
  if (!tier) return 0;
  return WEEKLY_LIMITS[tier] ?? 0;
}
